import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

/**
 * Interface for update user payload
 */
export interface UpdateUserPayload {
  username?: string;
  email?: string;
  phone_number?: string;
  first_name?: string;
  last_name?: string;
  country_code?: string;
  date_of_birth?: string;
  display_photo?: string;
  address?: string;
  referral?: string;
  role?: string;
  country?: string;
}

/**
 * Hook for updating user profile using TanStack React Query
 */
export const useUpdateUser = (
  dispatch: (action: any) => void,
  getUser: () => void,
  setImage: (value: { show: boolean; type: string }) => void,
  user: any
) => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: UpdateUserPayload) => {
      const response = await apiClient.patch<void>('/auth/user/', payload);
      return response.data;
    },
    onSuccess: () => {
      getUser();
      setImage({ show: false, type: '' });
      openToast({
        show: true,
        heading: 'Profile update successful!',
        text: '',
        type: 'success',
        timeOut: 2000,
      });
    },
    onError: (err: any) => {
      console.error('Update User Error:', err); // Log error for debugging
      const errorMessage =
        err?.response?.data?.error?.message ||
        'Failed to update your personal profile, please try again later';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};